import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import config from "../config";
import moment from "moment";

const JobButton = ({
    auth,
    often,
    cancelScheduleJob,
    schedule_id,
    care_giver_id,
    status,
    acceptJob,
    startJob,
    startJobCustomer,
    endJob,
    onChangeTime,
    customer_id,
    job_status,
    schedule,
}) => {
    console.log("schedule.job_date",schedule.job_date,moment(schedule.job_date).isSameOrAfter(moment().date()),moment());

    let toReturn = null;
    let changeTimeBtn = null;
    if (job_status != config.jobConstants.CANCELLED) {
        if (
            status != config.jobConstants.CANCELLED &&
            status != config.jobConstants.COMPLETED &&
            status != config.jobConstants.PROGRESS &&
            status != config.jobConstants.ACCEPTED &&
            care_giver_id != auth.user.id
        ) {
            changeTimeBtn = (
                <>
                    <button
                        type="button"
                        className="button btn star_job"
                        onClick={() => onChangeTime(schedule_id)}
                    >
                        Change Time
                    </button>
                    {
                        often === "weekly" &&
                        <button
                            type="button"
                            className="button btn star_job"
                            onClick={() => cancelScheduleJob(schedule_id)}
                        >
                            Cancel Job
                        </button>
                    }
                </>
            );
        } else {
            changeTimeBtn = null;
        }
        if (
            status == config.jobConstants.PENDING &&
            care_giver_id == auth.user.id
        ) {
            toReturn = (
                <>
                    <button
                        type="button"
                        className="button btn star_job"
                        onClick={() => acceptJob(schedule_id)}
                    >
                        Accept Job
                    </button>
                </>
            );
        } else if (
            status == config.jobConstants.ACCEPTED &&
            care_giver_id == auth.user.id
        ) {
            toReturn = (
                <button
                    disabled={!moment(schedule.job_date).isSameOrAfter(moment().date())}
                    type="button"
                    className="button btn star_job"
                    onClick={() => startJob(schedule_id)}
                >
                    Start Job
                </button>
            );
        } else if (
            status == config.jobConstants.PROGRESS &&
            care_giver_id == auth.user.id
        ) {
            toReturn = (
                <button
                    disabled={!moment(schedule.job_date).isSameOrAfter(moment().date())}
                    type="button"
                    className="button btn star_job"
                    onClick={() => endJob(schedule_id)}
                >
                    End Job
                </button>
            );
        } else if (
            status == config.jobConstants.PENDING_ON_USER_CONFIRMATION &&
            customer_id == auth.user.id
        ) {
            toReturn = (
                <button
                    type="button"
                    className="button btn star_job"
                    onClick={() => startJobCustomer(schedule_id)}
                >
                    Start Job
                </button>
            );
        } else {
            toReturn = null;
        }
    }

    return (
        <>
            {toReturn}
            {changeTimeBtn}
        </>
    );
};

JobButton.propTypes = {
    schedule_id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    acceptJob: PropTypes.func,
    startJob: PropTypes.func,
    endJob: PropTypes.func,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(JobButton);
